/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import categoryImagePlaceholder from 'assets/images/default-placeholder.jpg';
import {type VenueFormProps, type CategoryStatusList} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import Select, {type MultiValue} from 'react-select';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {AGREEMENT_STATUS, variables} from 'utils/constant';
const VenueForm: React.FC<VenueFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editVenue,
}) => {
  console.log('🚀 ~ editVenue:', editVenue);
  const [status] = useState([
    {id: variables.CLUB_ACTIVE_STATUS_ID, name: variables.CLUB_ACTIVE_STATUS},
    {
      id: variables.CLUB_INACTIVE_STATUS_ID,
      name: variables.CLUB_INACTIVE_STATUS,
    },
  ]);

  const [VenueTypeOption, setVenueTypeOption] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  const mappedDressCode = editVenue?.venue_type?.map((value: any) => {
    return {
      value: value?.id,
      label: value?.name,
    };
  });

  useEffect(() => {
    setSelectedOptions(mappedDressCode);
  }, []);

  const [imageDisplay, setImageDisplay] = useState<string>();

  const CountryCode: any = [{id: '+971', name: 'UAE'}];
  const dubaiNumberRegex = /^(3|4|5|6|7|9|50|51|52|55|56)[0-9]{7}$/;
  // /^(50|52|54|55|56|57|58|59|60|65|66|67|68|69)[0-9]{7}$/;

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editVenue?.name !== '' ? editVenue?.name : '',
      mobile_number:
        editVenue?.mobile_number !== '' ? editVenue?.mobile_number : '',
      image: editVenue?.image !== '' ? editVenue?.image : undefined,
      is_active: editVenue?.is_active !== '' ? editVenue?.is_active : '',
      address: editVenue?.address !== '' ? editVenue?.address : '',
      VenueType: editVenue?.venue_type?.length !== 0 ? mappedDressCode : [],
      country_code:
        editVenue?.country_code !== '' || editVenue?.country_code !== null
          ? editVenue?.country_code
          : '+971',
      VenueAgreement:
        editVenue?.agreement_status !== '' ? editVenue?.agreement_status : '',
      VenueManagerName:
        editVenue?.venue_manager?.name !== ''
          ? editVenue?.venue_manager?.name
          : '',
      VenueManagerPhoneNumber:
        editVenue?.venue_manager?.phone_number !== ''
          ? editVenue?.venue_manager?.phone_number
          : '',
      VenueManagerCountryCode:
        editVenue?.venue_manager?.country_code !== ''
          ? editVenue?.venue_manager?.country_code
          : '+971',
      // parent_id:
      //   editVenue?.parent_id !== '' ? editVenue?.parent_id : null,
      // status: editVenue?.status !== '' ? editVenue?.status : '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Venue name is required'),
      mobile_number: Yup.string()
        .matches(
          dubaiNumberRegex,
          'Phone number must start with a valid Dubai prefix and contain 7 digits after the prefix',
        )
        .required('Phone number is required'),
      // parent_id: Yup.string().notRequired(),
      image: Yup.mixed().required('Image is required'),
      is_active: Yup.number().required('Status is required'),
      address: Yup.string().required('Address is required'),
      VenueType: Yup.mixed().required('Venue type is required'),
      VenueAgreement: Yup.number().required('Venue aggreement is required'),
      VenueManagerName: Yup.string().required('Venue manager name is required'),
      VenueManagerPhoneNumber: Yup.string()
        .matches(
          dubaiNumberRegex,
          'Phone number must start with a valid Dubai prefix and contain 7 digits after the prefix',
        )
        .required("Venue manager's phone number is required"),
    }),
    onSubmit: async (values: any): Promise<void> => {
      /** ***********  ✨ Codeium Command ⭐  *************/
      /**
       * Submit the form data to the server. If the submission is successful, call
       * setIsEditCategory and setIsAddCategory to toggle the edit and add category
       * states, close the modal, and show a success toast message. If the submission
       * fails, show an error toast message.
       *
       * @param {object} values - The form data to be submitted.
       * @returns {Promise<void>}
       */
      /** ****  7505cdff-94e9-48b7-9d08-77c097fd5a58  *******/
      // console.log('🚀 ~ onSubmit: ~ values:', values);

      const payloadForDressCode: any = {};

      selectedOptions?.forEach((element: any, index: any): any => {
        payloadForDressCode[`${index}`] = {id: element.value};
      });

      try {
        const formData = {
          name: values.name,
          mobile_number: values.mobile_number,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          // status: values.status,
          // ...(editVenue?.id
          //   ? {is_active: editVenue?.is_active}
          //   : {is_active: ''}),
          is_active: values?.is_active,
          ...(editVenue?.id ? {} : {status: 1}),
          // parent_id: values.parent_id,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editVenue?.id ? {id: editVenue?.id} : {}),
          ...(typeof values?.image !== 'string' ? {image: values?.image} : {}),
          // brand: selectedBrandOption.map((brand: any, index: number) => ({
          //   id: brand.value,
          // })),
          venue_type: payloadForDressCode,
          address: values?.address,
          agreement_status: values?.VenueAgreement,
          country_code: values?.country_code || '+971',
          venue_manager: {
            name: values?.VenueManagerName,
            phone_number: values?.VenueManagerPhoneNumber,
            country_code: values?.VenueManagerCountryCode || '+971',
          },
        };
        // if (typeof values?.image !== 'string' && values?.image) {
        //   (formData as any).image = values?.image;
        // }
        // console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editVenue?.id
            ? await ApiUtils.updateVenue(formData)
            : await ApiUtils.addVenue(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  const handleImage = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];

    if (file !== null && file) {
      const validImageTypes = [
        'image/jpeg',
        'image/png',
        'image/jpg',
        'image/webp',
      ];

      if (!validImageTypes.includes(file?.type)) {
        // console.error(
        //   'Invalid file type. Please upload an image of type: jpeg, png, jpg, gif, svg, webp. 111111',
        // );
        alert(
          'Invalid file type. Please upload an image of type: jpeg, png, jpg,webp',
        );
        return; // Exit the function if the file type is not valid
      }

      const objectUrl: string = URL.createObjectURL(file);
      setImageDisplay(objectUrl);
      console.log('🚀 ~ handleImage ~ objectUrl:', objectUrl, file);

      validation.setFieldValue('image', file);
    }
  };

  useEffect(() => {
    // fetch venue type
    const fetchVenueTypeList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.TypeVenue(); // Ensure parentheses
        const mapData = response?.data?.map((option: any) => {
          return {
            value: option.id,
            label: option.name,
          };
        });

        setVenueTypeOption(mapData || []); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching dress code list:', error);
      }
    };
    void fetchVenueTypeList();
  }, []);

  const handleSelectDressCodeChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setSelectedOptions([...selectedOptions]); // Convert read-only array to mutable array
    validation.setFieldValue('VenueType', [...selectedOptions]);
  };
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />
          <Col
            lg={12}
            className="d-flex justify-content-center align-items-center">
            <div className="mb-3 category-img">
              <label
                htmlFor="category-image-input"
                className="form-label d-block text-center">
                Image <span className="text-danger">*</span>
              </label>

              <div className="avatar-upload">
                <div className="avatar-edit">
                  <input
                    type="file"
                    id="imageUpload"
                    onChange={handleImage}
                    accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                  />
                  <label
                    htmlFor="imageUpload"
                    className="image-upload-cam d-flex justify-content-center align-items-center">
                    <i className="ri-image-fill"></i>
                  </label>
                </div>
                <div className="avatar-preview">
                  <img
                    className="preview-select-img img-responsive img-circle"
                    id="imagePreview"
                    alt="Venue picture"
                    src={
                      imageDisplay ??
                      (editVenue?.id && editVenue?.image !== ''
                        ? editVenue?.image
                        : categoryImagePlaceholder)
                    }
                    style={{height: '110px'}}
                  />
                </div>
              </div>
              {Boolean(validation.touched.image) &&
              Boolean(validation.errors.image) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.image}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Venue Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.VenueName} />
              </div>
              <Form.Control
                type="text"
                id="venue-name"
                placeholder="Enter Venue Name"
                name="name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.name || editVenue?.name
                    ? editVenue?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.name) &&
                    Boolean(validation.errors.name)
                  )
                }
              />
              {Boolean(validation.touched.name) &&
              Boolean(validation.errors.name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Phone Number
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.VenuePhoneNumber} />
              </div>
              <div className="d-flex">
                <Form.Select
                  className="form-select"
                  style={{width: 'fit-content'}}
                  name="country_code"
                  id="country_code"
                  disabled={true} // Keep the dropdown disabled
                  value={
                    validation.values.country_code ||
                    editVenue?.country_code ||
                    '+971' // Default value
                  }
                  onChange={e =>
                    validation.setFieldValue('country_code', e.target.value)
                  }>
                  {CountryCode?.map(
                    (
                      data: {id: string; name: string},
                      i: React.Key | null | undefined,
                    ) => (
                      <option key={i} value={data.id}>
                        {data.id}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Control
                  type="text"
                  id="venue-phone-number"
                  placeholder="Enter phone number"
                  name="mobile_number"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  defaultValue={
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                    validation?.values?.mobile_number ||
                    editVenue?.mobile_number
                      ? editVenue?.mobile_number
                      : ''
                  }
                  isInvalid={
                    !!(
                      Boolean(validation.touched.mobile_number) &&
                      Boolean(validation.errors.mobile_number)
                    )
                  }
                />
              </div>

              {Boolean(validation.touched.mobile_number) &&
              Boolean(validation.errors.mobile_number) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.mobile_number}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.VenueStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="is_active"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('is_active', e.target.value)
                }
                value={
                  validation.values.is_active ||
                  (editVenue?.is_active !== '' ? editVenue?.is_active : '')
                }
                isInvalid={
                  !!(
                    validation.touched.is_active && validation.errors.is_active
                  )
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.is_active) &&
              Boolean(validation.errors.is_active) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.is_active}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Venue Address</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.VenueAddress} />
              </div>
              <Form.Control
                as="textarea"
                id="address"
                name="address"
                rows={4}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.address}
                isInvalid={
                  Boolean(validation.touched.address) &&
                  !(validation.errors.address == null)
                }
              />

              {Boolean(validation.touched.address) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.address as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Type of Venue</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.VenueType} />
              </div>
              {/* <Form.Select
                className="form-select"
                name="VenueType"
                id="VenueType"
                onChange={e =>
                  validation.setFieldValue('VenueType', e.target.value)
                }
                value={
                  validation.values.VenueType ||
                  (editVenue?.VenueType !== '' ? editVenue?.VenueType : '')
                }
                isInvalid={
                  !!(
                    validation.touched.VenueType && validation.errors.VenueType
                  )
                }>
                <option value=" ">Type of Venue</option>
                {VenueTypeOption?.map(
                  (
                    data: CategoryStatusList,
                    i: React.Key | null | undefined,
                  ) => (
                    <option key={i} value={String(data.id)}>
                      {data.name}
                    </option>
                  ),
                )}
              </Form.Select> */}

              <Select
                isMulti
                className="custom-select"
                id="VenueType"
                name="VenueType"
                value={selectedOptions}
                onChange={handleSelectDressCodeChange}
                options={VenueTypeOption}></Select>

              {Boolean(validation.touched.VenueType) &&
              Boolean(validation.errors.VenueType) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.VenueType}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">
                  Venue Agreement Status
                </Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.VenueAgreement} />
              </div>
              <Form.Select
                className="form-select"
                name="VenueAgreement"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('VenueAgreement', e.target.value)
                }
                value={
                  validation.values.VenueAgreement ||
                  (editVenue?.VenueAgreement !== ''
                    ? editVenue?.VenueAgreement
                    : '')
                }
                isInvalid={
                  !!(
                    validation.touched.VenueAgreement &&
                    validation.errors.VenueAgreement
                  )
                }>
                <option value=" ">Venue Agreement</option>
                {AGREEMENT_STATUS?.map(
                  (
                    data: CategoryStatusList,
                    i: React.Key | null | undefined,
                  ) => (
                    <option key={i} value={data.id}>
                      {data.name}
                    </option>
                  ),
                )}
              </Form.Select>

              {Boolean(validation.touched.VenueAgreement) &&
              Boolean(validation.errors.VenueAgreement) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.VenueAgreement}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Venue Manager Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.VenueManagerName} />
              </div>
              <Form.Control
                type="text"
                id="VenueManagerName"
                placeholder="Enter venue Manager Name"
                name="VenueManagerName"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.VenueManagerName ||
                  editVenue?.venue_manager?.name
                    ? editVenue?.venue_manager?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.VenueManagerName) &&
                    Boolean(validation.errors.VenueManagerName)
                  )
                }
              />
              {Boolean(validation.touched.VenueManagerName) &&
              Boolean(validation.errors.VenueManagerName) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.VenueManagerName}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Venue Managaer Phone Number
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon
                  text={tooltipMessage.VenueManagerPhoneNumber}
                />
              </div>
              <div className="d-flex">
                <Form.Select
                  className="form-select"
                  style={{width: 'fit-content'}}
                  name="VenueManagerCountryCode"
                  id="VenueManagerCountryCode"
                  disabled={true}
                  onChange={e =>
                    validation.setFieldValue(
                      'VenueManagerCountryCode',
                      e.target.value,
                    )
                  }
                  value={
                    editVenue?.venue_manager?.country_code !== ''
                      ? editVenue?.venue_manager?.country_code
                      : ''
                  }>
                  {CountryCode?.map(
                    (
                      data: CategoryStatusList,
                      i: React.Key | null | undefined,
                    ) => (
                      <option
                        key={i}
                        value={data.id}
                        selected={String(data.id) === '+971'}>
                        {data.id}
                      </option>
                    ),
                  )}
                </Form.Select>
                <Form.Control
                  type="text"
                  id="venue-manager-phone-number"
                  placeholder="Enter venue manager's phone number"
                  name="VenueManagerPhoneNumber"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  defaultValue={
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                    validation?.values?.VenueManagerPhoneNumber ||
                    editVenue?.venue_manager?.phone_number
                      ? editVenue?.venue_manager?.phone_number
                      : ''
                  }
                  isInvalid={
                    !!(
                      Boolean(validation.touched.VenueManagerPhoneNumber) &&
                      Boolean(validation.errors.VenueManagerPhoneNumber)
                    )
                  }
                />
              </div>

              {Boolean(validation.touched.VenueManagerPhoneNumber) &&
              Boolean(validation.errors.VenueManagerPhoneNumber) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.VenueManagerPhoneNumber}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editVenue?.id !== undefined ? 'Edit Venue' : 'Add Venue'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default VenueForm;
